export const INVALIDATE_ON_ANSWER_KEY = 'invalidate-on-answer';
